// @generated by protoc-gen-es v1.3.2
// @generated from file rbt/v1alpha1/errors.proto (package rbt.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message rbt.v1alpha1.StateAlreadyConstructed
 */
export const StateAlreadyConstructed = proto3.makeMessageType(
  "rbt.v1alpha1.StateAlreadyConstructed",
  [],
);

/**
 * @generated from message rbt.v1alpha1.StateNotConstructed
 */
export const StateNotConstructed = proto3.makeMessageType(
  "rbt.v1alpha1.StateNotConstructed",
  () => [
    { no: 1, name: "requires_constructor", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message rbt.v1alpha1.UnknownService
 */
export const UnknownService = proto3.makeMessageType(
  "rbt.v1alpha1.UnknownService",
  [],
);

/**
 * @generated from message rbt.v1alpha1.InvalidMethod
 */
export const InvalidMethod = proto3.makeMessageType(
  "rbt.v1alpha1.InvalidMethod",
  [],
);

/**
 * @generated from message rbt.v1alpha1.UnknownTask
 */
export const UnknownTask = proto3.makeMessageType(
  "rbt.v1alpha1.UnknownTask",
  [],
);

/**
 * @generated from message rbt.v1alpha1.TransactionParticipantFailedToPrepare
 */
export const TransactionParticipantFailedToPrepare = proto3.makeMessageType(
  "rbt.v1alpha1.TransactionParticipantFailedToPrepare",
  [],
);

/**
 * @generated from message rbt.v1alpha1.TransactionParticipantFailedToCommit
 */
export const TransactionParticipantFailedToCommit = proto3.makeMessageType(
  "rbt.v1alpha1.TransactionParticipantFailedToCommit",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Cancelled
 */
export const Cancelled = proto3.makeMessageType(
  "rbt.v1alpha1.Cancelled",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Unknown
 */
export const Unknown = proto3.makeMessageType(
  "rbt.v1alpha1.Unknown",
  [],
);

/**
 * @generated from message rbt.v1alpha1.InvalidArgument
 */
export const InvalidArgument = proto3.makeMessageType(
  "rbt.v1alpha1.InvalidArgument",
  [],
);

/**
 * @generated from message rbt.v1alpha1.DeadlineExceeded
 */
export const DeadlineExceeded = proto3.makeMessageType(
  "rbt.v1alpha1.DeadlineExceeded",
  [],
);

/**
 * @generated from message rbt.v1alpha1.NotFound
 */
export const NotFound = proto3.makeMessageType(
  "rbt.v1alpha1.NotFound",
  [],
);

/**
 * @generated from message rbt.v1alpha1.AlreadyExists
 */
export const AlreadyExists = proto3.makeMessageType(
  "rbt.v1alpha1.AlreadyExists",
  [],
);

/**
 * @generated from message rbt.v1alpha1.PermissionDenied
 */
export const PermissionDenied = proto3.makeMessageType(
  "rbt.v1alpha1.PermissionDenied",
  [],
);

/**
 * @generated from message rbt.v1alpha1.ResourceExhausted
 */
export const ResourceExhausted = proto3.makeMessageType(
  "rbt.v1alpha1.ResourceExhausted",
  [],
);

/**
 * @generated from message rbt.v1alpha1.FailedPrecondition
 */
export const FailedPrecondition = proto3.makeMessageType(
  "rbt.v1alpha1.FailedPrecondition",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Aborted
 */
export const Aborted = proto3.makeMessageType(
  "rbt.v1alpha1.Aborted",
  [],
);

/**
 * @generated from message rbt.v1alpha1.OutOfRange
 */
export const OutOfRange = proto3.makeMessageType(
  "rbt.v1alpha1.OutOfRange",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Unimplemented
 */
export const Unimplemented = proto3.makeMessageType(
  "rbt.v1alpha1.Unimplemented",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Internal
 */
export const Internal = proto3.makeMessageType(
  "rbt.v1alpha1.Internal",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Unavailable
 */
export const Unavailable = proto3.makeMessageType(
  "rbt.v1alpha1.Unavailable",
  [],
);

/**
 * @generated from message rbt.v1alpha1.DataLoss
 */
export const DataLoss = proto3.makeMessageType(
  "rbt.v1alpha1.DataLoss",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Unauthenticated
 */
export const Unauthenticated = proto3.makeMessageType(
  "rbt.v1alpha1.Unauthenticated",
  [],
);

/**
 * @generated from message rbt.v1alpha1.Ok
 */
export const Ok = proto3.makeMessageType(
  "rbt.v1alpha1.Ok",
  [],
);

